import {StatutDossierEnums} from "@common/enum/StatutDossier.enum";
import {TranslateService} from "@ngx-translate/core";
import {MomentService} from "@digicerba/common";
import {DossierDto, IDossierWebServiceClient} from "@resources/resources";
import {Component, Input} from "@angular/core";


@Component({
  selector: 'historique-dossier',
  templateUrl: './historique-dossier.component.html'
})
export class HistoriqueDossierComponent {

  @Input() dossier: DossierDto;

  messagesRetards: string[] = [];

  etapes: Array<{ name: string, valide: boolean, attente: boolean, description: string, tooltip: string }>;

  tooltipHistoriqueTelechargement: string = "";
  downloadedByUser: boolean = false

  constructor(private momentService: MomentService, private translateService: TranslateService, private dossierWebServiceClient: IDossierWebServiceClient) {
  }

  ngOnInit() {
    this.getMessagesRetards();
    this.onDownload();
  }

  ngOnChanges() {
    this.etapes = new Array<{ name: string, valide: boolean, attente: boolean, description: string, tooltip: string }>();

    let currentStatut: StatutDossierEnums = StatutDossierEnums.getByCode(this.dossier.statutDossier);

    this.etapes.push({
      name: "PAGE.DETAIL-RESULTAT.HISTORIQUE.creation",
      valide: this.dossier.statutDossier != null,
      attente: false,
      description: this.momentService.formatDate(this.dossier.dateDossier),
      tooltip: null
    });
    if (this.dossier.dateControle != null) {
      this.etapes.push({
        name: "PAGE.DETAIL-RESULTAT.HISTORIQUE.controle",
        valide: currentStatut.order() >= StatutDossierEnums.getByCode('EN_CONTROLE').order(),
        attente: false,
        description: this.momentService.formatDate(this.dossier.dateControle),
        tooltip: null
      });
    }

    if (currentStatut.order() < StatutDossierEnums.getByCode('VALIDE_COMPLET').order()) {
      this.etapes.push({
        name: "PAGE.DETAIL-RESULTAT.HISTORIQUE.renduResultat",
        valide: false,
        attente: true,
        description: this.getDescriptionRenduResultat(),
        tooltip: null
      });
    } else {
      this.etapes.push({
        name: "PAGE.DETAIL-RESULTAT.HISTORIQUE.renduResultat",
        valide: true,
        attente: false,
        description: this.momentService.formatDate(this.dossier.dateValideComplet) + "<br>" + this.generateMessageString(this.messagesRetards),
        tooltip: null
      });
    }
    this.etapes.push({
      name: "PAGE.DETAIL-RESULTAT.HISTORIQUE.fin",
      valide: currentStatut.order() == StatutDossierEnums.getByCode('TERMINE').order(),
      attente: currentStatut.order() == StatutDossierEnums.getByCode('VALIDE_COMPLET').order(),
      description: this.momentService.formatDate(this.dossier.dateFin),
      tooltip: null
    });
    this.etapes.push({
      name: "PAGE.DETAIL-RESULTAT.HISTORIQUE.telechargement",
      valide: this.downloadedByUser,
      attente: false,
      description: this.downloadedByUser ? this.momentService.formatDate(this.dossier.dateDernierTelechargement) : null,
      tooltip: this.downloadedByUser ? this.tooltipHistoriqueTelechargement : null
    });
  }

  private getDescriptionRenduResultat() {
    if (this.dossier.dateSortiePrevisionnelle && new Date(this.dossier.dateSortiePrevisionnelle) > new Date()) {
      return this.translateService.instant("PAGE.DETAIL-RESULTAT.HISTORIQUE.dateEstime") + " " + this.momentService.formatDate(this.dossier.dateSortiePrevisionnelle)
        + "<br>" + this.generateMessageString(this.messagesRetards);
    }

    return this.generateMessageString(this.messagesRetards);
  }

  onDownload() {
    this.dossierWebServiceClient.findHistoriqueTelechargementDossier(this.dossier.identifiant).subscribe(data => {
      data.forEach(item => {
        this.downloadedByUser = true;
        this.tooltipHistoriqueTelechargement += item.filename + " " + item.username + " " + this.formatDate(item.dateTelechargement) + " " + item.ip + " \n";
        this.ngOnChanges();
      });
    });
  }

  getMessagesRetards() {
    this.dossierWebServiceClient.messageRetard(this.dossier.identifiant).subscribe(data => {
      data.forEach(item => {
        this.messagesRetards.push(item);
      });
      this.ngOnChanges();
    });
  }

  formatDate(date: any) {
    return date.dayOfMonth + "/" + date.monthValue + "/" + date.year;
  }

  generateMessageString(messageArray: string[]): string {
    switch (messageArray.length) {
      case 0:
        return "";
      case 1:
        return "<span>" + messageArray[0] + "</span>";
      default:
        return "<span>" + messageArray.join("<br>") + "</span>";
    }
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/detail-resultat/entete/historique/historique-dossier.component.ts